export const GET_PRODUCT_LIST = {
  URL: "/v3/aea5d98a-654d-4423-bd99-6fbb90843730",
  METHOD: "GET",
};